module.exports = __webpack_public_path__ + "img/chargingstation.3524aa8e.svg";